import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AIService } from './store/service'

@NgModule({
  imports: [CommonModule],
  providers: [AIService],
})
export class AiModule {}
